import WizTableForm from "../wizTableForm";
import organization from "./config-organization";
let organizationByUserConfig = organization(this, { apiParams: { state: 1} });

const columns = () => {
  return [
    {
      title: '所属组织',
      name: 'orgId',
      dataIndex: 'orgId',
      searchItem: {
        ...organizationByUserConfig,
        diy: WizTableForm,
        selectType: 'radio',
        initialValue: [],
        initRows: [],
        // rules: [
        //   {
        //     required: true,
        //     message: '所属组织必选'
        //   }
        // ]
      }
    },
    {
      title: '用户属性',
      name: 'userType',
      dataIndex: 'userType',
      searchItem: {type: 'select'},
      dict: [
        { code: 0, codeName: "学员" },
        { code: 1, codeName: "SGM总部" },
        { code: 2, codeName: "SGM区域" },
        { code: 3, codeName: "供应商" }
      ]
    },
    {
      title: '姓名',
      name: 'fullName',
      dataIndex: 'fullName',
      searchItem: {},
    },
    {
      title: '账号',
      name: 'userName',
      dataIndex: 'userName',
      searchItem: {},
      tableItem: {
        width: 100
      }
    },
    {
      title: '姓名',
      name: 'fullName',
      dataIndex: 'fullName',
      tableItem: {
        width: 100
      }
    },
    {
      title: '报名状态',
      name: 'applyState',
      dataIndex: 'applyState',
      tableItem: {
        width: 100
      },
      dict: [
        {code:0,codeName:'未报名'},
        {code:1,codeName:'已报名'}
      ]
    },
    {
      title: '手机号',
      name: 'mobile',
      dataIndex: 'mobile',
      tableItem: {
        width: 120
      }
    },
    {
      title: '身份证号/工号',
      name: 'idCard',
      dataIndex: 'idCard',
      tableItem: {
        width: 180
      }
    },
    {
      title: '岗位',
      name: 'positionName',
      dataIndex: 'positionName',
      tableItem: {
        width: 200
      }
    },
    {
      title: '状态',
      name: 'jobState',
      dataIndex: 'jobState',
      tableItem: {
        width: 80
      },
      dict: [
        {code:0,codeName:'离职'},
        {code:1,codeName:'在职'}
      ]
    },
    {
      title: '用户属性',
      name: 'userType',
      dataIndex: 'userType',
      tableItem: {
        width: 110
      },
      dict: [
        {code: 0, codeName: "学员"},
        {code: 1, codeName: "SGM总部"},
        {code: 2, codeName: "SGM区域"},
        {code: 3, codeName: "供应商"}
      ]
    },
    {
      title: '组织名称',
      name: 'orgName',
      dataIndex: 'orgName',
      tableItem: {
        width: 150
      }
    },
    {
      title: '经销商编码',
      name: 'orgCode',
      dataIndex: 'orgCode',
      tableItem: {
        width: 200
      }
    },
    {
      title: '账号状态',
      name: 'accountStateDisabled',
      dataIndex: 'accountStateDisabled',
      tableItem: {
        width: 90
      },
      dict:[
        { code: 1, codeName: "禁用" },
        { code: 0, codeName: "激活" }
      ]
    },
  ]
};

const tableApi = (api = {}) => {
  return {
    path: 'apply/queryApplyStudentRecordPage',
    ...api
  }
};

const applyStudentRecord = (self, api) => {
  if (api?.apiParams?.isNotAuth) {
    organizationByUserConfig = organization(this, { apiParams: { state: 1, isNotAuth: true} });
  }

  return {
    type: 'diy',
    initialValue: [],
    columns: columns(self),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    rowkey: 'id',
    rowTitle: 'userName',
    rowName: 'fullName',
    tableApi: tableApi(api)
  }
};

export default applyStudentRecord
